import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

const app = getApp();
// =============================== BASE  ===============================  //

export const REF = {
  NAME: "draft",
  COLLECTIONS: {
    DIALOG_EDITED: "dialogEdited",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    dialogEdited: collection(firestore, REF.COLLECTIONS.DIALOG_EDITED),
    //
  };
  return CREF;
};
